// Theme configuration for tournament viewer
// Themes can be selected via URL parameter: ?theme=blue

export const themes = {
  default: {
    name: 'Sports Control Hub',
    gradient: 'from-black to-gray-900',
    primary: 'emerald',
    primaryShades: {
      50: 'bg-emerald-50',
      100: 'bg-emerald-100',
      200: 'bg-emerald-200',
      400: 'bg-emerald-400',
      500: 'bg-emerald-500',
      600: 'bg-emerald-600',
      700: 'bg-emerald-700',
    },
    secondary: 'blue',
    secondaryShades: {
      50: 'bg-blue-50',
      100: 'bg-blue-100',
      200: 'bg-blue-200',
      400: 'bg-blue-400',
      500: 'bg-blue-500',
      600: 'bg-blue-600',
      700: 'bg-blue-700',
    },
    text: {
      primary: 'text-emerald-400',
      secondary: 'text-blue-400',
    },
    border: {
      primary: 'border-white/10',
      primaryHover: 'border-emerald-400/50',
      secondary: 'border-white/10',
    },
    ribbon: '🏆',
    message: 'Powered by Sports Control Hub',
  },
  pink: {
    name: 'Breast Cancer Awareness',
    gradient: 'from-pink-400 via-pink-500 to-rose-600',
    primary: 'pink',
    primaryShades: {
      50: 'bg-pink-50',
      100: 'bg-pink-100',
      200: 'bg-pink-200',
      500: 'bg-pink-500',
      600: 'bg-pink-600',
      700: 'bg-pink-700',
    },
    secondary: 'rose',
    secondaryShades: {
      50: 'bg-rose-50',
      100: 'bg-rose-100',
      200: 'bg-rose-200',
      500: 'bg-rose-500',
      600: 'bg-rose-600',
      700: 'bg-rose-700',
    },
    text: {
      primary: 'text-pink-600',
      secondary: 'text-rose-600',
    },
    border: {
      primary: 'border-pink-200',
      primaryHover: 'border-pink-400',
      secondary: 'border-rose-200',
    },
    ribbon: '🎗️',
    message: 'Supporting Breast Cancer Awareness',
  },
  blue: {
    name: 'Ocean Blue',
    gradient: 'from-blue-400 via-blue-500 to-indigo-600',
    primary: 'blue',
    primaryShades: {
      50: 'bg-blue-50',
      100: 'bg-blue-100',
      200: 'bg-blue-200',
      500: 'bg-blue-500',
      600: 'bg-blue-600',
      700: 'bg-blue-700',
    },
    secondary: 'indigo',
    secondaryShades: {
      50: 'bg-indigo-50',
      100: 'bg-indigo-100',
      200: 'bg-indigo-200',
      500: 'bg-indigo-500',
      600: 'bg-indigo-600',
      700: 'bg-indigo-700',
    },
    text: {
      primary: 'text-blue-600',
      secondary: 'text-indigo-600',
    },
    border: {
      primary: 'border-blue-200',
      primaryHover: 'border-blue-400',
      secondary: 'border-indigo-200',
    },
    ribbon: '🏆',
    message: 'Powered by PickleStack',
  },
  green: {
    name: 'Forest Green',
    gradient: 'from-emerald-400 via-green-500 to-teal-600',
    primary: 'emerald',
    primaryShades: {
      50: 'bg-emerald-50',
      100: 'bg-emerald-100',
      200: 'bg-emerald-200',
      500: 'bg-emerald-500',
      600: 'bg-emerald-600',
      700: 'bg-emerald-700',
    },
    secondary: 'teal',
    secondaryShades: {
      50: 'bg-teal-50',
      100: 'bg-teal-100',
      200: 'bg-teal-200',
      500: 'bg-teal-500',
      600: 'bg-teal-600',
      700: 'bg-teal-700',
    },
    text: {
      primary: 'text-emerald-600',
      secondary: 'text-teal-600',
    },
    border: {
      primary: 'border-emerald-200',
      primaryHover: 'border-emerald-400',
      secondary: 'border-teal-200',
    },
    ribbon: '🌲',
    message: 'Powered by PickleStack',
  },
  purple: {
    name: 'Royal Purple',
    gradient: 'from-purple-400 via-purple-500 to-violet-600',
    primary: 'purple',
    primaryShades: {
      50: 'bg-purple-50',
      100: 'bg-purple-100',
      200: 'bg-purple-200',
      500: 'bg-purple-500',
      600: 'bg-purple-600',
      700: 'bg-purple-700',
    },
    secondary: 'violet',
    secondaryShades: {
      50: 'bg-violet-50',
      100: 'bg-violet-100',
      200: 'bg-violet-200',
      500: 'bg-violet-500',
      600: 'bg-violet-600',
      700: 'bg-violet-700',
    },
    text: {
      primary: 'text-purple-600',
      secondary: 'text-violet-600',
    },
    border: {
      primary: 'border-purple-200',
      primaryHover: 'border-purple-400',
      secondary: 'border-violet-200',
    },
    ribbon: '👑',
    message: 'Powered by PickleStack',
  },
  orange: {
    name: 'Sunset Orange',
    gradient: 'from-orange-400 via-orange-500 to-red-600',
    primary: 'orange',
    primaryShades: {
      50: 'bg-orange-50',
      100: 'bg-orange-100',
      200: 'bg-orange-200',
      500: 'bg-orange-500',
      600: 'bg-orange-600',
      700: 'bg-orange-700',
    },
    secondary: 'red',
    secondaryShades: {
      50: 'bg-red-50',
      100: 'bg-red-100',
      200: 'bg-red-200',
      500: 'bg-red-500',
      600: 'bg-red-600',
      700: 'bg-red-700',
    },
    text: {
      primary: 'text-orange-600',
      secondary: 'text-red-600',
    },
    border: {
      primary: 'border-orange-200',
      primaryHover: 'border-orange-400',
      secondary: 'border-red-200',
    },
    ribbon: '🌅',
    message: 'Powered by PickleStack',
  },
  slate: {
    name: 'Professional Slate',
    gradient: 'from-slate-400 via-slate-500 to-gray-600',
    primary: 'slate',
    primaryShades: {
      50: 'bg-slate-50',
      100: 'bg-slate-100',
      200: 'bg-slate-200',
      500: 'bg-slate-500',
      600: 'bg-slate-600',
      700: 'bg-slate-700',
    },
    secondary: 'gray',
    secondaryShades: {
      50: 'bg-gray-50',
      100: 'bg-gray-100',
      200: 'bg-gray-200',
      500: 'bg-gray-500',
      600: 'bg-gray-600',
      700: 'bg-gray-700',
    },
    text: {
      primary: 'text-slate-600',
      secondary: 'text-gray-600',
    },
    border: {
      primary: 'border-slate-200',
      primaryHover: 'border-slate-400',
      secondary: 'border-gray-200',
    },
    ribbon: '⚡',
    message: 'Powered by PickleStack',
  },
  fire: {
    name: 'Inferno Fire',
    gradient: 'from-red-500 via-orange-600 to-yellow-500',
    primary: 'red',
    primaryShades: {
      50: 'bg-red-50',
      100: 'bg-red-100',
      200: 'bg-red-200',
      500: 'bg-red-500',
      600: 'bg-red-600',
      700: 'bg-red-700',
    },
    secondary: 'orange',
    secondaryShades: {
      50: 'bg-orange-50',
      100: 'bg-orange-100',
      200: 'bg-orange-200',
      500: 'bg-orange-500',
      600: 'bg-orange-600',
      700: 'bg-orange-700',
    },
    text: {
      primary: 'text-red-600',
      secondary: 'text-orange-600',
    },
    border: {
      primary: 'border-red-200',
      primaryHover: 'border-red-400',
      secondary: 'border-orange-200',
    },
    ribbon: '🔥',
    message: 'Ignite Your Competition',
  },
}

// Get theme from URL parameter or default to Sports Control Hub theme
export const getTheme = () => {
  const params = new URLSearchParams(window.location.search)
  const themeParam = params.get('theme')
  
  if (themeParam && themes[themeParam]) {
    return themes[themeParam]
  }
  
  return themes.default
}

// Get theme name from URL or default
export const getThemeName = () => {
  const params = new URLSearchParams(window.location.search)
  const themeParam = params.get('theme')
  
  if (themeParam && themes[themeParam]) {
    return themeParam
  }
  
  return 'default'
}
